import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import authStore from "../utils/authStorage";

export default function ProtectedRoute({ children, requireRole }) {
  const token = authStore.token;
  const [validation, setValidation] = useState(null);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (!token) return;
    const controller = new AbortController();
    const base = process.env.REACT_APP_API_BASE_URL || "";

    axios.get(`${base}/api/auth/session`, {
      headers: { Authorization: `Bearer ${token}` },
      signal: controller.signal,
      timeout: 15000,
    }).then(({ data }) => {
      if (controller.signal.aborted || authStore.token !== token) return;
      setValidation({ token, attempt, status: "valid", role: data.role });
    }).catch((error) => {
      if (controller.signal.aborted || authStore.token !== token) return;
      const expired = [401, 403].includes(error.response?.status);
      if (expired) authStore.clearAll();
      setValidation({ token, attempt, status: expired ? "expired" : "error" });
    });

    return () => controller.abort();
  }, [token, attempt]);

  if (validation?.status === "expired" && !token) {
    return <Navigate to="/login" replace state={{ sessionExpired: true }} />;
  }
  if (!token) return <Navigate to="/login" replace />;
  if (validation?.token !== token || validation?.attempt !== attempt) {
    return <p role="status">Checking your session...</p>;
  }
  if (validation.status === "error") {
    return (
      <div role="alert">
        <p>We could not check your session. Please check your connection and try again.</p>
        <button type="button" onClick={() => setAttempt((value) => value + 1)}>
          Try again
        </button>
      </div>
    );
  }

  if (requireRole !== undefined && String(validation.role) !== String(requireRole)) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
